/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export enum VideoPlayerName {
  SHAKA_PLAYER = "ShakaPlayer"
}
